import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  Self,
  SimpleChanges
} from '@angular/core';
import { NgControl } from '@angular/forms';

export interface SelectOption {
  text: string;
  value: string;
}

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit, OnChanges {

  @Input() name: string;
  @Input() options: SelectOption[];
  @Input() error: string;
  @Input() label: string;
  @Input() showLabel = true;
  @Output() optionChange: EventEmitter<any> = new EventEmitter<any>();

  value: string = null;

  constructor(@Self() @Optional() private control: NgControl) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showSuccess(): boolean {
    if (!this.control) {
      return false;
    }
    const {dirty, touched} = this.control;
    return !this.control.invalid ? (dirty || touched) : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }
    const {dirty, touched} = this.control;
    return this.invalid ? (dirty || touched) : false;
  }

  onChange: (value: string[]) => void = () => {
  }

  onTouched = () => {
  }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any): void {
    this.value = value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options?.isFirstChange() && changes.options?.currentValue) {
     if (this.value === '' || changes.options.currentValue[0].value === this.value) {
      this.value = changes.options.currentValue[0].value;
      this.optionChange.emit(changes.options.currentValue[0].value);
     }
    }
  }

}
